/* ============================================================
   PETHROOM JP — 투명 헤더 상태 제어

   <html>에 .ph-header-float 를 붙였다 뗀다.
     붙어 있음 → 헤더 투명 + 그라데이션 스크림
     떼어짐   → 원래 컬러 (스타일은 pethroom-renewal.css)

   붙이는 조건 (모두 만족해야 함)
     1. 첫 섹션이 이미지 배너인 페이지
     2. 아직 그 배너 영역 안에 있을 것 (스크롤로 벗어나면 뗀다)
     3. 마우스를 쓰는 환경일 것 (터치 기기는 호버가 없어 계속 투명하면 글씨가 안 보인다)
     4. 화면이 좁지 않을 것

   되돌리려면 theme.liquid에서 이 파일 로드 한 줄만 지우면 된다.
   ============================================================ */

(function () {
  'use strict';

  var ROOT = document.documentElement;
  var FLOAT_CLASS = 'ph-header-float';
  var MIN_WIDTH = 750;

  // 마우스를 쓰는 환경인지 — 터치 전용 기기는 제외
  var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  var header = document.querySelector('.peth-room-header');
  if (!header) return;

  // 헤더 바로 다음에 오는 첫 섹션이 이미지 배너인지 확인
  var banner = document.querySelector('.ph-banner-section, .ph-banner, .ph-hhero-section, .ph-hhero');
  if (!banner) return;

  var firstSection = document.querySelector('#MainContent > [id^="shopify-section-"], main > [id^="shopify-section-"]');
  var bannerIsFirst = firstSection ? firstSection.contains(banner) : true;
  if (!bannerIsFirst) return;

  function canFloat() {
    return hasHover.matches && window.innerWidth >= MIN_WIDTH;
  }

  var headerOffset = null;
  var bannerBottomDocY = null;

  // theme.js가 스크롤에 따라 .header 에 .is-solid 를 붙였다 뗀다(95px↔47px)
  function headerIsCollapsed() {
    var inner = header.querySelector('.header');
    return !!(inner && inner.classList.contains('is-solid'));
  }

  /* 배너 아래쪽 끝의 *문서* 좌표. 뷰포트 기준 rect 대신 문서 좌표를 쓰는 이유는
     아래 isOverBanner() 주석 참고. margin-top이 정적이 된 뒤로 이 값은 안정적이다. */
  function measureBanner() {
    bannerBottomDocY = banner.getBoundingClientRect().bottom + window.scrollY;
  }

  /* 배너가 헤더 아래 영역과 겹쳐 있는지.

     ⚠️ 예전 구현은 banner.getBoundingClientRect() 를 그대로 읽었다. 그런데
     이 판정의 결과(.ph-header-float)가 바로 그 배너의 margin-top을 바꿨기
     때문에, 판정이 자기가 재는 대상을 움직이는 피드백 루프가 됐다.
     CSS 쪽에서 margin-top을 정적 미디어쿼리로 옮겨 루프는 이미 끊었지만,
     여기서도 클래스가 건드릴 수 없는 문서 좌표로 비교해 재발을 구조적으로
     막는다. (scrollY < 배너하단문서좌표 - 헤더높이) 는 예전 식
     (rect.bottom > headerHeight) 과 수학적으로 동치다. */
  function isOverBanner() {
    if (bannerBottomDocY === null) measureBanner();
    return window.scrollY < bannerBottomDocY - (headerOffset || 0);
  }

  /* 헤더 줄 높이를 CSS 변수로 넘긴다.
     이 값만큼 배너를 위로 끌어올려 헤더가 배너 위에 겹치게 만든다.
     (어나운스먼트 바(노란 띠)는 KR과 동일하게 불투명으로 남기므로 계산에서 뺀다.)

     반드시 *펼친(비-.is-solid)* 높이만 캐시한다. 접힌 높이를 그대로 넣으면
     끌어올리는 거리 자체가 스크롤 의존이 되어(실측: 한 번의 스크롤에서
     heroMT가 0 / -47 / -95px로 요동) 헤더가 접히는 순간 배너가 눈에 띄게 튄다.

     접힌 상태를 걸러내는 것만으로는 부족하다. 웹폰트가 로드되는 동안 헤더는
     접히지 않은 채로도 높이가 47→79→83→95px 로 커지며 안정된다. 그 중간값을
     캐시하면 로드 중에 배너가 16px 튄다(실측: heroMT 가 -79px 와 -95px 두 값).
     펼친 높이는 항상 그 구간의 *최댓값*이므로, 뷰포트가 바뀔 때까지는
     최댓값만 채택한다 — 단조 증가라 중간값에 걸리지 않는다. */
  function syncOffset() {
    if (headerIsCollapsed()) return;
    var total = Math.round(header.getBoundingClientRect().height);
    if (!total) return;
    if (headerOffset !== null && total <= headerOffset) return;
    headerOffset = total;
    ROOT.style.setProperty('--ph-header-offset', total + 'px');
  }

  /* 뷰포트가 바뀌면 펼친 높이 자체가 달라진다(1512→-95px, 2560→-120px,
     768→-42px). 최댓값 캐시를 버리고 새로 잡는다. */
  function resetOffset() {
    headerOffset = null;
    syncOffset();
  }

  /* update()는 이제 클래스만 토글한다. syncOffset()을 여기서 부르면
     레이아웃이 다시 스크롤 의존이 되어 위 트랩이 되살아난다. */
  function update() {
    if (canFloat() && isOverBanner()) {
      ROOT.classList.add(FLOAT_CLASS);
    } else {
      ROOT.classList.remove(FLOAT_CLASS);
    }
  }

  /* 레이아웃 기준값 갱신 — 스크롤과 무관한 사건에서만 호출한다 */
  function remeasure() {
    syncOffset();
    measureBanner();
  }

  /* 스크롤 감지는 IntersectionObserver로 한다.
     requestAnimationFrame은 탭이 백그라운드면 멈춰서 상태가 어긋난다. */
  var observer = null;
  var lastObservedHeight = null;

  function observe() {
    if (observer) observer.disconnect();
    if (!('IntersectionObserver' in window)) return;

    var headerHeight = Math.round(header.getBoundingClientRect().height);
    lastObservedHeight = headerHeight;
    observer = new IntersectionObserver(update, {
      rootMargin: '-' + headerHeight + 'px 0px 0px 0px',
      threshold: [0, 0.001]
    });
    observer.observe(banner);
  }

  remeasure();
  update();
  observe();

  // 웹폰트가 늦게 로드되면 헤더/배너 높이가 바뀌므로 기준값을 다시 잡는다
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      remeasure();
      update();
      observe();
    });
  }

  /* .is-solid(스크롤 트래커, theme.js)가 토글되면 헤더 높이가 120px↔60px로
     바뀐다. 위 observer의 rootMargin은 observe() 호출 시점 높이를 고정값으로
     박아두므로, 높이가 바뀐 뒤에는 stale해져서 다음 스크롤 방향 전환부터
     threshold 계산이 어긋나 update()가 더 이상 제대로 안 붙는다(재현: 아래→위→
     아래 스크롤 2회차부터 배경이 안 바뀜). ResizeObserver로 실제 높이 변화를
     감지해 매번 재기준(re-baseline)한다. */
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(function () {
      var h = Math.round(header.getBoundingClientRect().height);
      if (h !== lastObservedHeight) {
        /* syncOffset()은 접힌 상태면 내부에서 스스로 무시하므로, 여기서
           불러도 --ph-header-offset 이 스크롤 의존으로 되돌아가지 않는다.
           배너 문서 좌표는 헤더 높이가 흐름에 영향을 주므로 항상 갱신한다. */
        remeasure();
        observe();
        update();
      }
    });
    resizeObserver.observe(header);
  }

  // IntersectionObserver가 없는 환경을 위한 대비책
  if (!('IntersectionObserver' in window)) {
    window.addEventListener('scroll', update, { passive: true });
  }

  window.addEventListener(
    'resize',
    function () {
      resetOffset();
      measureBanner();
      update();
      observe();
    },
    { passive: true }
  );

  // 입력 방식이 바뀌는 경우(태블릿에 마우스 연결 등)도 반영
  if (hasHover.addEventListener) {
    hasHover.addEventListener('change', update);
  } else if (hasHover.addListener) {
    hasHover.addListener(update);
  }

  // 테마 편집기에서 섹션을 다시 그릴 때 재계산
  document.addEventListener('shopify:section:load', function () {
    remeasure();
    update();
    observe();
  });
  document.addEventListener('shopify:section:unload', function () {
    remeasure();
    update();
  });
})();

/* ============================================================
   메가패널 1열을 자기 트리거(商品カテゴリー) 아래에 정렬

   CSS만으로는 못 푼다. 컬럼은 패널 안에 있고 트리거는 패널 밖 내비 행에
   있어서, 둘의 x를 맞추려면 실측값이 필요하다. 그 값을 --ph-mega-col1-x로
   넘기면 pethroom-renewal.css의 .peth-mega__col:first-child가 받아 쓴다.

   기준점은 "패널의 컨텐츠 박스 좌변"이다. margin-inline-start가 그 기준으로
   재기 때문이다. 거터를 정확히 한 번만 빼야 한다:
     .peth-mega 는 absolute + inset-inline:0 이고 containing block은
     .header__primary-nav(position:relative)의 *padding box*다. padding box의
     좌변은 padding을 포함한 바깥쪽, 즉 border box 좌변과 같다(테두리 없음).
     그래서 패널은 nav 폭 전체를 덮는다 — 실측으로 확인(1920px에서 0→1920).
     여기에 .peth-mega 자신의 padding-inline(--ph-gutter)만 안쪽으로 더해진다.
   즉 컬럼 기준 좌변 = 패널 좌변 + mega.paddingLeft 하나뿐이다.
     - 아무것도 안 빼면 1열이 88px 오른쪽으로 밀리고
     - nav.paddingLeft까지 같이 빼면 88px 왼쪽으로 밀린다(둘 다 실측으로 확인).

   패널이 닫혀 있어도(display:none) getComputedStyle은 padding 계산값을
   돌려주므로 최초 로드 시점에도 동작한다. 레이아웃이 있으면 실측 rect를 쓴다.
   ============================================================ */
(function () {
  'use strict';

  var nav = document.querySelector(
    '.peth-room-header .peth-room-mobile-nav .header__primary-nav'
  );
  if (!nav) return;

  // :has()를 지원하지 않는 브라우저는 CSS의 clamp() 폴백에 맡긴다
  function firstMegaItem() {
    try {
      return nav.querySelector('.header__primary-nav-item:has(.peth-mega)');
    } catch (e) {
      var mega = nav.querySelector('.peth-mega');
      return mega ? mega.closest('.header__primary-nav-item') : null;
    }
  }

  function sync() {
    var li = firstMegaItem();
    if (!li) return;

    var mega = nav.querySelector('.peth-mega');
    if (!mega) return;

    // 패널 border box 좌변 — 열려 있으면 실측, 닫혀 있으면 nav에서 유도
    var megaRect = mega.getBoundingClientRect();
    var panelLeft = megaRect.width > 0
      ? megaRect.left
      : nav.getBoundingClientRect().left + nav.clientLeft;

    var padL = parseFloat(getComputedStyle(mega).paddingLeft) || 0;

    var x = li.getBoundingClientRect().left - (panelLeft + padL);
    if (!isFinite(x) || x < 0) x = 0;

    nav.style.setProperty('--ph-mega-col1-x', Math.round(x) + 'px');
  }

  sync();
  window.addEventListener('resize', sync, { passive: true });
  document.addEventListener('shopify:section:load', sync);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(sync);
  }
})();

/* ============================================================
   H2 — 티커의 prefers-reduced-motion 대응

   홈 티커는 Prestige 코어 섹션 scrolling-content 를 그대로 쓴다.
   그 <marquee-text> 는 shadow root 의 [part="scroller"] 에 WAAPI
   애니메이션을 직접 걸고, prefers-reduced-motion 을 전혀 보지 않는다
   (헤드리스로 확인: reduce 로 켜도 transform 이 계속 움직인다).

   theme.js 는 코어라 손대지 않는다(AGENTS.md §5). 대신 여기서 해당
   애니메이션만 취소한다. 글자는 그대로 남고 흐르기만 멈춘다.
   ============================================================ */
(function () {
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mq) return;

  var watched = (typeof WeakSet === 'function') ? new WeakSet() : null;

  function freezeOne(el) {
    if (!mq.matches) return;
    if (!el.shadowRoot) return;
    var scroller = el.shadowRoot.querySelector('[part="scroller"]');
    if (!scroller || !scroller.getAnimations) return;
    scroller.getAnimations().forEach(function (a) {
      a.cancel();
    });
  }

  function watchOne(el) {
    if (watched) {
      if (watched.has(el)) return;
      watched.add(el);
    }

    // 코어의 initialize_fn 은 attachShadow → 클론 5개 append → animate() 를
    // 한 번의 동기 실행 안에서 끝낸다. append 가 일으킨 childList 뮤테이션
    // 콜백은 마이크로태스크라 그 동기 블록이 끝난 뒤에 돌아온다. 즉 이
    // 콜백이 뛰는 시점에는 애니메이션이 이미 존재하므로, 폴링 없이
    // 정확히 한 번에 잡을 수 있다.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        freezeOne(el);
      }).observe(el, { childList: true });
    }

    // inView 가 이미 지나가서 초기화가 끝난 뒤에 우리가 도착했을 수도 있다.
    freezeOne(el);
  }

  function scan() {
    var list = document.querySelectorAll('marquee-text');
    for (var i = 0; i < list.length; i++) watchOne(list[i]);
  }

  function freezeAll() {
    var list = document.querySelectorAll('marquee-text');
    for (var i = 0; i < list.length; i++) freezeOne(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // 테마 에디터에서 섹션을 다시 그리면 marquee-text 노드 자체가 교체된다.
  document.addEventListener('shopify:section:load', scan);

  // reduce 를 나중에 켠 경우. 반대로 끄는 쪽은 되돌리지 않는다 —
  // 취소한 WAAPI 애니메이션은 코어를 건드리지 않고는 되살릴 수 없다.
  // 새로고침하면 정상 복귀한다.
  if (mq.addEventListener) mq.addEventListener('change', freezeAll);
})();
